module.exports = __webpack_public_path__ + "img/banner-1.795e2efa.jpg";